<template>
  <UlDialog v-model="dialog" persistent :loading="loading || !partnerSelected" :buttons="buttons">
    <template v-if="partnerSelected" #title>
      <v-img max-height="40" contain :src="partnerSelected.logo" :alt="partnerSelected.name" />
    </template>
    <template #text>
      <div>
        <template v-if="partnerSelected">
          <i18n
            v-if="$te(`profileAuthorization.external.${partnerSelected.partnerUrl}Text`)"
            data-cy="partnerLoginRegistrationText"
            :path="`profileAuthorization.external.${partnerSelected.partnerUrl}Text`"
          >
            <template #title>
              {{ $t(`profileAuthorization.external.titleSlot`) }}
            </template>
          </i18n>
          <div v-else>
            {{ $t('profileAuthorization.external.defaultErrorText') }}
          </div>
        </template>
      </div>
    </template>
  </UlDialog>
</template>

<script>
export default {
  name: 'ExternalLoginRegistration',
  computed: {
    partnerSelected() {
      return this.$store.state.profile.externalPartner.partnerSelected;
    },
    loading() {
      return this.$store.state.profile.externalPartner.checkTokenLoading;
    },
    dialog: {
      get() {
        return this.$store.state.profile.externalPartner.externalRegistrationDialog;
      },
      set(value) {
        this.$store.commit(`profile/externalPartner/setExternalRegistrationDialog`, value);
      }
    },
    buttons() {
      if (
        !!this.partnerSelected?.redirectUrl &&
        (!!this.partnerSelected?.isActive || this.partnerSelected?.isActive === undefined)
      ) {
        return [
          {
            props: {
              href: this.partnerSelected.redirectUrl
            },
            text: this.$t('loginText')
          }
        ];
      }
      return [
        {
          events: {
            click: () => {
              this.dialog = false;
            }
          },
          text: this.$t('close')
        }
      ];
    }
  }
};
</script>
